export enum RoomType {
    Bedroom = 'BEDROOM',
    ChildrenRoom = 'CHILDREN_ROOM',
    OfficeRoom = 'OFFICE_ROOM',
    GuestRoom = 'GUEST_ROOM',
    LivingRoom = 'LIVING_ROOM',
    GeneralRoom = 'GENERAL_ROOM',
    Hall = 'HALL',
    Kitchen = 'KITCHEN',
    Bathroom = 'BATHROOM',
    WC = 'WC',
    UtilityRoom = 'UTILITY_ROOM',
    StorageRoom = 'STORAGE_ROOM',
    Washroom = 'WASHROOM'
}
